<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            small
            text
            icon
            color="primary"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
        <span>Update Confirm Date</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Employee Confirm Date"
      text="Update Confirm Date"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-menu
                v-model="confirmDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Confirmed Date"
                    prepend-icon="event"
                    readonly
                    :value="confirmedDateDisplay"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="confirmedDate"
                  no-title
                  @input="confirmDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      employee: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        confirmedDate: null,
        confirmDateMenu: false,
      }
    },
    computed: {
      confirmedDateDisplay () {
        return this.confirmedDate
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.confirmedDate = this.employee.confirmed_date
        }
      },
    },
    methods: {
     
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.progressing = true

            this.$api.employees().updateConfirmedDate(this.employee.employee_uid, { confirmed_date: this.confirmedDate })
              .then(res => {
                this.$emit('updated')
                this.$snack({ message: res.data.status })
                this.dialog = false
              })
              .catch(e => {})
              .then(res => {
                this.progressing = false
                this.$snack({ message: res.data.status })
              })
          })
      },
    },
  }
</script>
